export type WatermarkStatuses =
  | 'watermarked'
  | 'not_watermarked'
  | 'watermark_removed'
  | 'failed'
  | 'processing'
export type WatermarkFilters = {
  watermarking_status: WatermarkStatuses | 'non-empty'
}
export const WATERMARKED = 'watermarked'
export const NOT_WATERMARKED = 'not_watermarked'
export const WATERMARK_REMOVED = 'watermark_removed'
export const FAILED = 'failed'
export const PROCESSING = 'processing'
